// Load More: fetches the next paginated page and appends product items.
// Uses event delegation so it survives DOM replacement by facets.js filtering.
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('#LoadMoreBtn');
    if (!btn) return;

    var container = document.getElementById('LoadMoreContainer');
    if (!container || container.dataset.busy) return;

    var nextUrl = container.dataset.nextUrl;
    if (!nextUrl) return;

    var grid = document.getElementById('product-grid');
    var countEl = document.getElementById('LoadMoreCount');
    var total = parseInt(container.dataset.total, 10);
    var showing = parseInt(container.dataset.showing, 10);

    container.dataset.busy = '1';
    btn.textContent = 'Loading…';

    fetch(nextUrl)
      .then(function (res) {
        if (!res.ok) throw new Error('Network error');
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newItems = doc.querySelectorAll('#product-grid .grid__item');
        var nextContainer = doc.getElementById('LoadMoreContainer');

        if (grid) {
          newItems.forEach(function (item) {
            grid.appendChild(item);
          });
        }

        showing += newItems.length;
        container.dataset.showing = showing;

        if (countEl) {
          countEl.textContent = 'Showing ' + showing + ' of ' + total + ' products';
        }

        if (nextContainer && nextContainer.dataset.nextUrl) {
          container.dataset.nextUrl = nextContainer.dataset.nextUrl;
          btn.textContent = 'Load more';
        } else {
          delete container.dataset.nextUrl;
          btn.remove();
        }
      })
      .catch(function () {
        btn.textContent = 'Load more';
      })
      .finally(function () {
        delete container.dataset.busy;
      });
  });
})();
